export default function SectionLabel({ kicker, title, intro, align = "center", invert = false }) {
  const alignClass = align === "left" ? "text-left" : "text-center mx-auto";
  return (
    <div className={`max-w-3xl ${alignClass}`}>
      <div className="flex items-center gap-3 mb-4 justify-start"
        style={{ justifyContent: align === "left" ? "flex-start" : "center" }}>
        <span className={`h-px w-10 ${invert ? "bg-gold/70" : "bg-sage"}`} />
        <span
          className={`text-[11px] uppercase tracking-[0.3em] font-sans font-medium ${
            invert ? "text-gold" : "text-sage-dark"
          }`}
        >
          {kicker}
        </span>
        <span className={`h-px w-10 ${invert ? "bg-gold/70" : "bg-sage"}`} />
      </div>
      <h2
        className={`font-serif text-[clamp(2rem,4vw,3.4rem)] leading-[1.1] ${
          invert ? "text-parchment-100" : "text-cocoa-900"
        }`}
      >
        {title}
      </h2>
      {intro && (
        <p
          className={`mt-6 font-sans text-base md:text-lg font-light leading-relaxed ${
            invert ? "text-parchment-200/85" : "text-cocoa-800"
          }`}
        >
          {intro}
        </p>
      )}
    </div>
  );
}
